var FormService = class FormService {
    constructor(enpointUrl) {
        this.enpointUrl = enpointUrl;
    }

    loadForm(formComponent, success, error) {

        //console.log('loadForm ', formComponent);

        let url = this.enpointUrl + "/formbuilder/" + formComponent.props.formName + "/" + formComponent.props.culture + "/" + formComponent.props.siteName;

        //console.log('fetching data from ' + url);
        return fetch(url, {
            method: 'get',
            mode: "cors",
            headers: {'Content-Type':'application/json'},
        }).then(response => {return response.json()})
            .then(responseJson => {
                success(responseJson, formComponent);
            })
            .catch(err => error(err));
    }

    postForm(formPayload, formComponent, success, error) {
        let url = this.enpointUrl + '/formbuilder';

        //console.log('posting data from ' + url);
        return fetch(url, {
            method: 'post',
            body: formPayload,
            headers: {
                RequestVerificationToken:
                    document.getElementsByName("__RequestVerificationToken")[0].value
            }
        }).then(response => response.json())
            .then(responseJson => {
                if (responseJson == true)
                    success(responseJson, formComponent);
                else
                    error(responseJson, formComponent);
            })
            .catch(err => error(err, formComponent));
    }

    verifyCaptchaToken(token, formComponent, success, error) {
        let url = this.enpointUrl + '/recaptcha/verifyCaptchaToken';
        return fetch(url, {
            method: 'post',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token: token })
        }).then(response => response.json())
            .then(responseJson => {
                success(responseJson, formComponent);
            })
            .catch(err => error(err));
    }
}

export default FormService;